export enum SpeedTestOrigin {
    SERVER = 'server',
    CLIENT = 'client',
}
